// extracted by mini-css-extract-plugin
module.exports = {"container":"RollingDisplay_container__H5e_r","label":"RollingDisplay_label__4UZVB","animateWrapper":"RollingDisplay_animateWrapper__eR0Lu","arrow":"RollingDisplay_arrow___fwTN"};